import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ZoomIn } from 'lucide-react';
import { CaseStudyModal } from './CaseStudyModal';
const cases = [{
  client: 'Major UK Supermarket Chain',
  title: 'Private Label Food Product Sourcing',
  metric: '30%',
  metricLabel: 'Cost Reduction',
  image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&q=80&w=800',
  tags: ['Food & Beverage', 'United Kingdom']
}, {
  client: 'European Hypermarket Group',
  title: 'Multi-Category FMCG Supply Program',
  metric: '200+',
  metricLabel: 'Products Listed',
  image: 'https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?auto=format&fit=crop&q=80&w=800',
  tags: ['FMCG', 'Europe']
}, {
  client: 'Asian Retail Distributor',
  title: 'European Brand Market Entry',
  metric: '12',
  metricLabel: 'New Markets',
  image: 'https://images.unsplash.com/photo-1489987707025-afc232f7ea0f?auto=format&fit=crop&q=80&w=800',
  tags: ['Market Entry', 'Asia-Pacific']
}];
export function CaseStudiesSection() {
  const [selectedCase, setSelectedCase] = useState<(typeof cases)[0] | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = (item: (typeof cases)[0]) => {
    setSelectedCase(item);
    setIsModalOpen(true);
  };
  return <section id="case-studies" className="py-24 bg-[#0a1628] overflow-hidden" data-id="element-62">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-63">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16" data-id="element-64">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-65">
            <span className="text-[#d4a853] font-medium tracking-[0.2em] uppercase text-sm block mb-4" data-id="element-66">
              Success Stories
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-white" data-id="element-67">
              Recent Sourcing Projects
            </h2>
          </motion.div>

          <motion.button initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="hidden md:flex items-center gap-2 text-white hover:text-[#d4a853] transition-colors font-medium mt-8 md:mt-0 uppercase tracking-wider text-sm" data-id="element-68">
            View All Projects <ArrowRight size={16} data-id="element-69" />
          </motion.button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-70">
          {cases.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="group cursor-pointer" onClick={() => openModal(item)} data-id="element-71">
              {/* Image Container */}
              <div className="relative h-64 mb-6 overflow-hidden border border-white/10" data-id="element-72">
                <div className="absolute inset-0 bg-[#0a1628]/40 group-hover:bg-transparent transition-colors duration-500 z-10" data-id="element-73" />
                <img src={item.image} alt={item.title} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700" data-id="element-74" />
                <div className="absolute bottom-0 left-0 bg-[#d4a853] text-[#0a1628] px-4 py-2 text-xs font-bold uppercase tracking-wider z-20" data-id="element-75">
                  {item.tags[0]}
                </div>

                {/* Hover Overlay Icon */}
                <div className="absolute inset-0 z-20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-76">
                  <div className="bg-[#0a1628]/80 p-3 rounded-full text-[#d4a853] backdrop-blur-sm" data-id="element-77">
                    <ZoomIn size={24} data-id="element-78" />
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="flex flex-col h-full" data-id="element-79">
                <div className="flex items-baseline gap-2 mb-2" data-id="element-80">
                  <span className="text-4xl font-bold text-[#d4a853]" data-id="element-81">
                    {item.metric}
                  </span>
                  <span className="text-sm text-gray-400 uppercase tracking-wide" data-id="element-82">
                    {item.metricLabel}
                  </span>
                </div>

                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-[#d4a853] transition-colors" data-id="element-83">
                  {item.title}
                </h3>

                <p className="text-gray-500 text-sm mb-4" data-id="element-84">{item.client}</p>

                <div className="mt-auto pt-4 border-t border-white/10 flex items-center justify-between" data-id="element-85">
                  <span className="text-xs text-gray-400 uppercase tracking-wider" data-id="element-86">
                    {item.tags[1]}
                  </span>
                  <ArrowRight className="w-4 h-4 text-[#d4a853] transform -translate-x-2 opacity-0 group-hover:translate-x-0 group-hover:opacity-100 transition-all" data-id="element-87" />
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center md:hidden" data-id="element-88">
          <button className="text-white border-b border-[#d4a853] pb-1 uppercase tracking-wider text-sm font-bold" data-id="element-89">
            View All Projects
          </button>
        </div>
      </div>

      <CaseStudyModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data={selectedCase} data-id="element-90" />
    </section>;
}